import { Form, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useUpdateUserConfigurationMutation } from "api/ecosternApi";
import { useAppSelector } from "store/hooks";
import { selectUserConfiguration } from "store/slices/userSlice";

const PRIVACY_POLICY_URL = process.env.REACT_APP_PRIVACY_POLICY_URL;

interface IProps {
    show: boolean;
    onHide: () => void;
}

export const PrivacyModal = ({ show, onHide }: IProps) => {
    const configuration = useAppSelector(selectUserConfiguration);
    const [updateConfiguration, { isLoading }] = useUpdateUserConfigurationMutation();

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton className={"bg-secondary"}>
                <Modal.Title>
                    <FormattedMessage id={"privacy.title"} />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className={"fs-sm"}>
                    <FormattedMessage id={"privacy.clientEventsDescription"} />
                </p>
                <p className={"fs-sm"}>
                    <FormattedMessage id={"privacy.clientEventsOptOut"} />
                </p>
                {PRIVACY_POLICY_URL && (
                    <p className={"fs-sm"}>
                        <a href={PRIVACY_POLICY_URL} target={"_blank"} rel={"noreferrer"}>
                            <FormattedMessage id={"privacy.policyLink"} />
                        </a>
                    </p>
                )}
                <Form.Check
                    type={"switch"}
                    id={"clientEventsEnabled"}
                    label={<FormattedMessage id={"privacy.clientEventsEnabled"} />}
                    checked={configuration?.clientEventsEnabled ?? true}
                    disabled={!configuration || isLoading}
                    onChange={(e) => updateConfiguration({ clientEventsEnabled: e.target.checked })}
                />
            </Modal.Body>
        </Modal>
    );
};
